const menu = {
    opener: document.getElementById('openNav'),
    closers: document.querySelectorAll('#closeNav, #btnSearch'),
    nav: document.getElementById('headerNav'),
    page: document.querySelector('body'),
    subOpener: document.querySelectorAll('.main-header__nav__main .menu-item-has-children'),
    subcloser: document.getElementById('closeSubNav'),
    nonClickable: document.querySelectorAll('.main-header__nav__main .menu-item-has-children > a'),
    scondaryNavToggler: document.querySelectorAll('.main-header__nav__secondary .menu-item-has-children'),
    htmltag: document.querySelector('html'),

	init: function() {
		this.homepageBackground();
		this.openNav();
		this.closeNav();
		this.openSubNav();
		this.closeSubNav();
		this.preventLinkToOpen();
		this.toggleSecondaryNav();
	},

	homepageBackground: function(){
		if( body.classList.contains('home') ){
			// Init on page load
			body.classList.toggle('headerBgd', (window.scrollY > 0));
			
			// Toggle on scroll event
			document.addEventListener('scroll', e => {
				body.classList.toggle('headerBgd', (window.scrollY > 0));
			});
		}
	},

	openNav: function(){
		this.opener.addEventListener('click', () => {

            this.page.classList.add('openMenu')
            this.htmltag.style.overflowX = "visible";
    
        })
	},

    closeNav: function(){
		this.closers.forEach(closer => {
			closer.addEventListener('click', () => {
				this.page.classList.remove('openMenu')
				this.htmltag.style.overflowX = "hidden";
			})
		})
    
	},

    openSubNav: function(){

        this.subOpener.forEach(opener => {
            opener.addEventListener('click', event => {
                event.stopPropagation();

				this.nav.classList.add('mainSubMenuOpen');
                opener.classList.add('active');
                opener.parentNode.classList.add('open');

                if(this.subcloser.classList.contains('n2')){
                    this.subcloser.classList.add('n3')
                }else{
                    this.subcloser.classList.add('n2')
                }
                
        
            })
        });
		
	},

    closeSubNav: function(){

        this.subcloser.addEventListener('click', () => {

			let baseSelector = '.main-header__nav__main > ul.open';
			let nRemove = 'n2';
            if(this.subcloser.classList.contains('n3')){
				baseSelector = '.main-header__nav__main ul.sub-menu.open';
				nRemove = 'n3';
            }
			document.querySelector(baseSelector+' > li.active').classList.remove('active')
			document.querySelector(baseSelector).classList.remove('open')
			this.subcloser.classList.remove(nRemove)

			if( nRemove == 'n2' ){
				this.nav.classList.remove('mainSubMenuOpen');
			}
        });
		
	},

    preventLinkToOpen: function(){
        this.nonClickable.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
            })
        });
    },

    toggleSecondaryNav: function(){

        this.scondaryNavToggler.forEach(toggler => {
            toggler.addEventListener('click', event => {
                event.preventDefault();
                toggler.classList.toggle('active');
            })
        });
		
	},
}

export default menu